import StudentTabsHeader from '../StudentTabsHeader';
import { SelectOptionType } from '@octano/global-ui';
import {
  PostulantInfo,
  StudyPlanEnrollmentsInfo,
} from '../../../StudentManagement/StudentFile/types';
import { useEffect, useMemo, useState } from 'react';
import StudentAcademicHistoryInfo from './parts/StudentAcademicHistoryInfo';
import AcademicHistoryTabs from './parts/AcademicHistorytabs';

interface AcademicHistoryProps {
  postulant: PostulantInfo;
  studyPlanEnrollments: SelectOptionType[];
  studyPlanEnrollmentsInfo: StudyPlanEnrollmentsInfo[];
}

export default function AcademicHistory({
  postulant,
  studyPlanEnrollments,
  studyPlanEnrollmentsInfo,
}: AcademicHistoryProps) {
  const [selectedStudyPlan, setSelectedStudyPlan] = useState<
    SelectOptionType | undefined
  >(undefined);

  useEffect(() => {
    if (studyPlanEnrollments && studyPlanEnrollments.length >= 1) {
      setSelectedStudyPlan(studyPlanEnrollments[0]);
    } else {
      setSelectedStudyPlan(undefined);
    }
  }, [studyPlanEnrollments]);

  const tutor = useMemo(() => {
    return (
      studyPlanEnrollmentsInfo.find(
        (item) =>
          item.studyPlanEnrollmentId === Number(selectedStudyPlan?.value),
      )?.tutor ?? null
    );
  }, [studyPlanEnrollmentsInfo, selectedStudyPlan]);

  return (
    <>
      <StudentTabsHeader name={postulant.fullName} id={postulant.rut} />
      <StudentAcademicHistoryInfo
        studyPlanEnrollments={studyPlanEnrollments}
        tutor={tutor}
        selectedStudyPlan={selectedStudyPlan}
        setSelectedStudyPlan={setSelectedStudyPlan}
      />
      <AcademicHistoryTabs
        studyPlanEnrollmentId={selectedStudyPlan?.value.toString()}
        studyPlanEnrollmentsInfo={studyPlanEnrollmentsInfo}
      />
    </>
  );
}
